import React, { useEffect, useState, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const MultiplicationRevealPuzzle = () => {
  const [baseNumber, setBaseNumber] = useState(2);
  const [tiles, setTiles] = useState([]);
  const [selected, setSelected] = useState([]);
  const [solved, setSolved] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState('');
  const audioRef = useRef(null);

  const images = [
    // "https://images.wallpapersden.com/image/ws-4k-spider-man-bike-adventure_91347.jpg"
    "https://images5.alphacoders.com/135/thumbbig-1351465.webp",
    "https://images2.alphacoders.com/137/thumbbig-1371730.webp",
    "https://images7.alphacoders.com/116/thumbbig-1162441.webp",
    "https://images3.alphacoders.com/819/thumbbig-819478.webp",
    "https://images7.alphacoders.com/135/thumbbig-1351772.webp",
    "https://images4.alphacoders.com/107/thumbbig-1078644.webp",
    "https://picfiles.alphacoders.com/231/thumb-1920-231452.jpg",
    "https://images8.alphacoders.com/114/thumbbig-1145761.webp",
    "https://images7.alphacoders.com/474/thumb-440-474234.webp"

  ];

  useEffect(() => {
    generatePuzzle(baseNumber);
  }, [baseNumber]);

  const generatePuzzle = (base) => {
    const correctMultiples = Array.from({ length: 10 }, (_, i) => base * (i + 1));

    const distractors = new Set();
    while (distractors.size < 10) {
      const rand = Math.floor(Math.random() * base * 12) + 1;
      if (!correctMultiples.includes(rand)) distractors.add(rand);
    }

    const allTiles = [...correctMultiples, ...distractors].sort(() => 0.5 - Math.random());

    const randomImage = images[Math.floor(Math.random() * images.length)];
    setBackgroundImage(randomImage);

    setTiles(allTiles);
    setSelected([]);
    setSolved(false);
  };

  const handleClick = (num) => {
    if (selected.includes(num)) return;

    const newSelected = [...selected, num];
    setSelected(newSelected);

    const correctSelections = newSelected.filter(n => n % baseNumber === 0);
    if (correctSelections.length === 10) {
      setSolved(true);

      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      audioRef.current.play();
    }
  };

  const handleDropdownChange = (e) => {
    const newValue = parseInt(e.target.value);
    setBaseNumber(newValue);
    generatePuzzle(newValue);
  };

  return (
    <div style={{
      fontFamily: 'Comic Sans MS, cursive',
      minHeight: '100vh',
      background: '#fffde7',
      padding: '30px',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '2.5rem', color: '#6a1b9a' }}>🧩 Reveal the Hidden Image!</h1>

      <label style={{ fontSize: '1.2rem' }}>Select a multiplication table: </label>
      <select value={baseNumber} onChange={handleDropdownChange} style={{
        marginLeft: '10px',
        fontSize: '1rem',
        padding: '5px 10px',
        borderRadius: '6px'
      }}>
        {Array.from({ length: 11 }, (_, i) => i + 2).map(n => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>

      <div style={{
        position: 'relative',
        width: '520px',
        height: '420px',
        margin: '30px auto',
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: '5px solid #ffcc80',
        borderRadius: '15px',
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 100px)',
        gridTemplateRows: 'repeat(4, 100px)',
        gap: '5px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
      }}>
        {!solved && tiles.map((num, idx) => {
          const isCorrect = num % baseNumber === 0;
          const isSelected = selected.includes(num);

          return (
            <div
              key={idx}
              onClick={() => handleClick(num)}
              style={{
                backgroundColor: isSelected && isCorrect ? 'transparent' : '#fff9c4',
                color: isSelected && isCorrect ? 'transparent' : '#000',
                border: '2px solid #fbc02d',
                fontSize: '1.3rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: isSelected ? 'default' : 'pointer',
                borderRadius: '10px',
                transition: '0.4s ease'
              }}
            >
              {num}
            </div>
          );
        })}
      </div>

      {solved && (
        <div style={{ marginTop: '20px' }}>
          <h2 style={{ color: '#2e7d32' }}>🎉 Puzzle Complete! You did it!</h2>
          <button
            onClick={() => generatePuzzle(baseNumber)}
            style={{
              marginTop: '15px',
              padding: '10px 20px',
              fontSize: '1rem',
              background: '#ffb74d',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer'
            }}
          >
            🔁 Play Again
          </button>
        </div>
      )}

      {/* 🎵 Celebration sound */}
      <audio ref={audioRef}>
        <source src="https://cdn.pixabay.com/download/audio/2023/03/01/audio_ef09e7a8aa.mp3?filename=kids-win-sound-1-183123.mp3" type="audio/mpeg" />
      </audio>
    </div>
  );
};

export default MultiplicationRevealPuzzle;
